import React from 'react';
import { 
  Box, 
  Typography, 
  Container, 
  Grid, 
  Paper,
  styled 
} from '@mui/material';
import { BarChart3, Users, Clock, DollarSign } from 'lucide-react';

const IconWrapper = styled(Box)(({ theme }) => ({
  width: 48,
  height: 48,
  backgroundColor: '#0d9488',
  borderRadius: theme.shape.borderRadius,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2)
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-4px)'
  }
}));

const WhyTile = ({ icon: Icon, title, description }) => {
  return (
    <StyledPaper elevation={3}>
      <IconWrapper>
        <Icon size={24} color="white" />
      </IconWrapper>
      <Typography 
        variant="h6" 
        component="h3" 
        sx={{ 
          color: '#0d9488',
          fontWeight: 600,
          mb: 1
        }}
      >
        {title}
      </Typography>
      <Typography 
        color="text.secondary"
        sx={{ flex: 1 }}
      >
        {description}
      </Typography>
    </StyledPaper>
  );
};

const WhySection = () => {
  const benefits = [
    {
      icon: BarChart3,
      title: "80% Less Abandonment",
      description: "Keep visitors engaged with instant answers to their questions"
    },
    {
      icon: Users,
      title: "50% More Engagement",
      description: "Increase user interaction and time spent on your site"
    },
    {
      icon: Clock,
      title: "4x Faster Responses",
      description: "Provide immediate assistance to customer inquiries"
    },
    {
      icon: DollarSign,
      title: "30% Cost Reduction",
      description: "Lower support costs while improving service quality"
    }
  ];

  return (
    <Box 
      component="section" 
      id="why"
      sx={{
        py: 8,
        bgcolor: 'grey.50'
      }}
    >
      <Container>
        <Typography 
          variant="h3" 
          component="h2"
          align="center"
          sx={{
            color: '#0d9488',
            fontWeight: 600,
            mb: 6
          }}
        >
          Why Search<span style={{ fontWeight: 900 }}>eble</span>?
        </Typography>
        
        <Grid container spacing={4}>
          {benefits.map((benefit, index) => (
            <Grid item xs={12} md={6} lg={3} key={index}>
              <WhyTile {...benefit} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default WhySection;